module.exports = __webpack_public_path__ + "static/media/6967.90e96f3c.jpg";